import React from 'react';
import { teamLeagueInfoUrl } from '../../utils/generalLiveCenter';

const RugbyTableRow = ({ data, sport = "rugby",
  websiteBaseUrl,
  dataPath, dataClient }) => {
  return (
    <tr>
      <td>
        <span className="d-inline-block align-middle">{data?.plc}</span>
      </td>
      <td>
        <div className="des-wrap">
          <a
            href={teamLeagueInfoUrl({
              dataClient,
              websiteBaseUrl,
              dataPath,
              category: "team",
              sport,
              name: data?.team?.nm,
              id: data?.team?.id,
            })}
          >


            <span className="des-text">{data?.team?.nm || data?.team}</span>
          </a>
        </div>
      </td>
      <td>{data?.pl}</td>
      <td>{data?.wo}</td>
      <td>{data?.dr}</td>
      <td>{data?.lo}</td>
      <td>{data?.pc}</td>
      <td>{data?.pts}</td>
      <td>
        <ul className="prev_match_status">
          {data.lfm.map((w, i) => (
            <li key={i} className={`${w === 'W' ? 'win' : 'loss'}`}>
              {w}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  );
};

export default RugbyTableRow;
